/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, { useState, useEffect } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { Layout } from "../_metronic/layout";
import IndexPage from "./IndexPage";
import { Logout, AuthPage } from "./modules/Auth";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";

export function Routes() {
  const [authenticated, setAuthenticated] = useState(false);

  const { isAuthorized } = useSelector(({ auth }) => {
    return {
      isAuthorized: auth.user != null,
    };
  }, shallowEqual);

  useEffect(() => {
    const auth = localStorage.getItem("token");

    if (auth !== "" && auth !== null) {
      setAuthenticated(true);
    }
  }, []);

  console.log("isAuthorized", localStorage.getItem("token"));

  return (
    <Switch>
      {/* {localStorage.getItem("token") === null ? (
				<Route>
					<AuthPage />
				</Route>
			) : (
				<Redirect from="/auth" to="/" />
			)}

			<Route path="/logout" component={Logout} />
			<Route path="/error" component={ErrorsPage} />

			{localStorage.getItem("token") === null ? (
				
				<Redirect to="/auth/login" />
			) : (
				<Layout>
					<BasePage />
				</Layout>
			)} */}
      <Route>
        <IndexPage />
      </Route>
    </Switch>
  );
}
